/** Keep in sync with micus-mono/src/lib/formGuards.ts `fields`. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_RE = /^\+?[0-9][0-9\s\-().]{6,19}$/;
